<template>
    <div>
        <div class="vx-row mb-4">
            <div class="vx-col w-full">
                <vx-card>
                    <vs-button @click.stop="onClickUpdateForecast">View/Update Forecast</vs-button>
                    <!-- <br>
                    <div class="vx-row mt-8">
                        <span v-for="(tool, index) in forecast_data" :key="index">
                            {{ tool.formulation_code }} <br>
                        </span>
                    </div> -->
                </vx-card>
            </div>
        </div>
        <UpdateForecast ref="updateForecast" @refreshData="refreshData" />
    </div>
</template>
<script>
import UpdateForecast from "@/components/popups/forecast-tool/UpdateForecast";

import { RepositoryFactory } from "@/repository/RepositoryFactory";
const ForecastRepository = RepositoryFactory.get('forecast')

export default {
    name: 'CustomerForecastTool',
    data() {
        return {
            forecast_data: []
        }
    },
    components: {
        UpdateForecast
    },
    props: {
        customer: {
            type: Object
        }
    },
    async mounted() {
        // await this.fetchForeCastTool()
        await this.onClickUpdateForecast()
    },
    methods: {
        async onClickUpdateForecast() {
            await this.$refs.updateForecast.openPopup({ data: this.customer, customer_type: 'customer' })
        },
        async refreshData() {
            
        },
        async fetchForeCastTool() {
            const { data } = (await ForecastRepository.getForecastList(`customer_id=${this.customer.id}`)).data
            if (data.length > 0) {
                this.forecast_data = data[0].forecast_tools
            } else {
                this.forecast_data = []
            }
        }
    }
}
</script>
<style lang="">
    
</style>